module.exports = __webpack_public_path__ + "img/section8-img5.b22b8923.png";